import { map, isEmpty, filter, includes } from 'lodash-es';
import { P as eventPath } from './p-0856cfca.js';
import { d as BxfOverlayController } from './p-7397c455.js';
import { B as BxfPositionConstants } from './p-31d5cbf5.js';

const { POPOVER_CONTAINER, CLASSNAME } = BxfPositionConstants.STRING;
class BxfOverlayPopoverController extends BxfOverlayController {
    host;
    parentElement;
    targetElement;
    sourceElement;
    updateStateCallback;
    options;
    isOutsideOverlayCallback;
    updatePositionCallback;
    constructor(host, parentElement, targetElement, sourceElement, updateStateCallback, options = {}, isOutsideOverlayCallback, updatePositionCallback // this is a code smell as there are too many parameters it is necessary for now
    ) {
        super(host, parentElement, targetElement, sourceElement, updateStateCallback, options, isOutsideOverlayCallback, updatePositionCallback);
        this.host = host;
        this.parentElement = parentElement;
        this.targetElement = targetElement;
        this.sourceElement = sourceElement;
        this.updateStateCallback = updateStateCallback;
        this.options = options;
        this.isOutsideOverlayCallback = isOutsideOverlayCallback;
        this.updatePositionCallback = updatePositionCallback;
    }
    appendToContainer(element) {
        super.createOverlayContainer();
        super.appendToContainer(element, POPOVER_CONTAINER);
    }
    isOutsidePopoverController(event, className) {
        const { MENU_CONTAINER, DROPDOWN_CONTAINER } = BxfPositionConstants.STRING;
        const classMap = map(eventPath(event), CLASSNAME);
        const dropdownController = isEmpty(filter(classMap, (value) => includes(value, DROPDOWN_CONTAINER)));
        const menuController = isEmpty(filter(classMap, (value) => includes(value, MENU_CONTAINER)));
        const popoverController = isEmpty(filter(classMap, (value) => includes(value, className)));
        return dropdownController && menuController && popoverController;
    }
    /**
     * Override element to return focus to when closing popover.
     * @protected
     * @returns {HTMLElement}
     */
    getInitiallyFocusedElem() {
        return this.parentElement;
    }
}

export { BxfOverlayPopoverController as B };
